"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: stock/testing/stock-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fstock%2Ftesting%2Fstock-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.testDocumentTypeToJSON = exports.testDocumentTypeFromJSON = exports.AddTestDocumentResponse = exports.AddTestDocumentRequest = exports.SetGraduationTransferDelayResponse = exports.SetGraduationTransferDelayRequest = exports.SetIgnoreMarketHoursResponse = exports.SetIgnoreMarketHoursRequest = exports.GetIgnoreMarketHoursResponse = exports.GetIgnoreMarketHoursRequest = exports.AddActivityResponse = exports.AddActivityRequestCashJournal = exports.AddActivityRequestWithdrawal = exports.AddActivityRequestDeposit = exports.AddActivityRequestInterestAdjustment = exports.AddActivityRequestMergerAcquisition = exports.AddActivityRequestStockSpinoff = exports.AddActivityRequestStockSplit = exports.AddActivityRequestStockAdjustment = exports.AddActivityRequestDividendTax = exports.AddActivityRequestDividend = exports.AddActivityRequest = exports.CreateOrderResponse = exports.CreateOrderRequestMarket = exports.CreateOrderRequestLimit = exports.CreateOrderRequest = exports.TestDocumentType = void 0;
const amount_1 = require("../../common/amount");
const stock_corporate_action_1 = require("../../common/stock-corporate-action");
const stock_order_1 = require("../../common/stock-order");
const protobufPackage = 'com.step.stock.internal.proto';
var TestDocumentType;
(function (TestDocumentType) {
    TestDocumentType["INVALID_TEST_DOCUMENT_TYPE"] = "INVALID_TEST_DOCUMENT_TYPE";
    TestDocumentType["MONTHLY_STATEMENT"] = "MONTHLY_STATEMENT";
    TestDocumentType["TRADE_CONFIRMATION"] = "TRADE_CONFIRMATION";
    TestDocumentType["TAX_DOCUMENT"] = "TAX_DOCUMENT";
    TestDocumentType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TestDocumentType || (exports.TestDocumentType = TestDocumentType = {}));
function createBaseCreateOrderRequest() {
    return { userId: '', symbol: '', side: stock_order_1.Side.INVALID_SIDE, limit: undefined, market: undefined };
}
exports.CreateOrderRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            side: isSet(object.side) ? (0, stock_order_1.sideFromJSON)(object.side) : stock_order_1.Side.INVALID_SIDE,
        };
        if (isSet(object.limit)) {
            message.limit = exports.CreateOrderRequestLimit.fromJSON(object.limit);
        }
        if (isSet(object.market)) {
            message.market = exports.CreateOrderRequestMarket.fromJSON(object.market);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.side !== stock_order_1.Side.INVALID_SIDE) {
            obj.side = (0, stock_order_1.sideToJSON)(message.side);
        }
        if (message.limit !== undefined) {
            obj.limit = exports.CreateOrderRequestLimit.toJSON(message.limit);
        }
        if (message.market !== undefined) {
            obj.market = exports.CreateOrderRequestMarket.toJSON(message.market);
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderRequest();
        message.userId = object.userId ?? '';
        message.symbol = object.symbol ?? '';
        message.side = object.side ?? stock_order_1.Side.INVALID_SIDE;
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? exports.CreateOrderRequestLimit.fromPartial(object.limit)
            : undefined;
        message.market = (object.market !== undefined && object.market !== null)
            ? exports.CreateOrderRequestMarket.fromPartial(object.market)
            : undefined;
        return message;
    },
};
function createBaseCreateOrderRequestLimit() {
    return { quantity: '', price: amount_1.Amount.fromPartial({}) };
}
exports.CreateOrderRequestLimit = {
    fromJSON(object) {
        const message = {
            quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderRequestLimit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderRequestLimit();
        message.quantity = object.quantity ?? '';
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCreateOrderRequestMarket() {
    return { quantity: '' };
}
exports.CreateOrderRequestMarket = {
    fromJSON(object) {
        const message = {
            quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderRequestMarket.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderRequestMarket();
        message.quantity = object.quantity ?? '';
        return message;
    },
};
function createBaseCreateOrderResponse() {
    return { orderId: '' };
}
exports.CreateOrderResponse = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderResponse();
        message.orderId = object.orderId ?? '';
        return message;
    },
};
function createBaseAddActivityRequest() {
    return {
        userId: '',
        amount: undefined,
        symbol: '',
        otherSymbol: '',
        recordedAtMs: '0',
        dividend: undefined,
        dividendTax: undefined,
        stockSplit: undefined,
        stockSpinoff: undefined,
        mergerAcquisition: undefined,
        interestAdjustment: undefined,
        stockAdjustment: undefined,
        deposit: undefined,
        withdrawal: undefined,
        cashJournal: undefined,
    };
}
exports.AddActivityRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.symbol)) {
            message.symbol = globalThis.String(object.symbol);
        }
        if (isSet(object.otherSymbol)) {
            message.otherSymbol = globalThis.String(object.otherSymbol);
        }
        if (isSet(object.recordedAtMs)) {
            message.recordedAtMs = globalThis.String(object.recordedAtMs);
        }
        if (isSet(object.dividend)) {
            message.dividend = exports.AddActivityRequestDividend.fromJSON(object.dividend);
        }
        if (isSet(object.dividendTax)) {
            message.dividendTax = exports.AddActivityRequestDividendTax.fromJSON(object.dividendTax);
        }
        if (isSet(object.stockSplit)) {
            message.stockSplit = exports.AddActivityRequestStockSplit.fromJSON(object.stockSplit);
        }
        if (isSet(object.stockSpinoff)) {
            message.stockSpinoff = exports.AddActivityRequestStockSpinoff.fromJSON(object.stockSpinoff);
        }
        if (isSet(object.mergerAcquisition)) {
            message.mergerAcquisition = exports.AddActivityRequestMergerAcquisition.fromJSON(object.mergerAcquisition);
        }
        if (isSet(object.interestAdjustment)) {
            message.interestAdjustment = exports.AddActivityRequestInterestAdjustment.fromJSON(object.interestAdjustment);
        }
        if (isSet(object.stockAdjustment)) {
            message.stockAdjustment = exports.AddActivityRequestStockAdjustment.fromJSON(object.stockAdjustment);
        }
        if (isSet(object.deposit)) {
            message.deposit = exports.AddActivityRequestDeposit.fromJSON(object.deposit);
        }
        if (isSet(object.withdrawal)) {
            message.withdrawal = exports.AddActivityRequestWithdrawal.fromJSON(object.withdrawal);
        }
        if (isSet(object.cashJournal)) {
            message.cashJournal = exports.AddActivityRequestCashJournal.fromJSON(object.cashJournal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.symbol !== undefined && message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.otherSymbol !== undefined && message.otherSymbol !== '') {
            obj.otherSymbol = message.otherSymbol;
        }
        if (message.recordedAtMs !== undefined && message.recordedAtMs !== '0') {
            obj.recordedAtMs = message.recordedAtMs;
        }
        if (message.dividend !== undefined) {
            obj.dividend = exports.AddActivityRequestDividend.toJSON(message.dividend);
        }
        if (message.dividendTax !== undefined) {
            obj.dividendTax = exports.AddActivityRequestDividendTax.toJSON(message.dividendTax);
        }
        if (message.stockSplit !== undefined) {
            obj.stockSplit = exports.AddActivityRequestStockSplit.toJSON(message.stockSplit);
        }
        if (message.stockSpinoff !== undefined) {
            obj.stockSpinoff = exports.AddActivityRequestStockSpinoff.toJSON(message.stockSpinoff);
        }
        if (message.mergerAcquisition !== undefined) {
            obj.mergerAcquisition = exports.AddActivityRequestMergerAcquisition.toJSON(message.mergerAcquisition);
        }
        if (message.interestAdjustment !== undefined) {
            obj.interestAdjustment = exports.AddActivityRequestInterestAdjustment.toJSON(message.interestAdjustment);
        }
        if (message.stockAdjustment !== undefined) {
            obj.stockAdjustment = exports.AddActivityRequestStockAdjustment.toJSON(message.stockAdjustment);
        }
        if (message.deposit !== undefined) {
            obj.deposit = exports.AddActivityRequestDeposit.toJSON(message.deposit);
        }
        if (message.withdrawal !== undefined) {
            obj.withdrawal = exports.AddActivityRequestWithdrawal.toJSON(message.withdrawal);
        }
        if (message.cashJournal !== undefined) {
            obj.cashJournal = exports.AddActivityRequestCashJournal.toJSON(message.cashJournal);
        }
        return obj;
    },
    create(base) {
        return exports.AddActivityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddActivityRequest();
        message.userId = object.userId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.symbol = object.symbol ?? '';
        message.otherSymbol = object.otherSymbol ?? '';
        message.recordedAtMs = object.recordedAtMs ?? '0';
        message.dividend = (object.dividend !== undefined && object.dividend !== null)
            ? exports.AddActivityRequestDividend.fromPartial(object.dividend)
            : undefined;
        message.dividendTax = (object.dividendTax !== undefined && object.dividendTax !== null)
            ? exports.AddActivityRequestDividendTax.fromPartial(object.dividendTax)
            : undefined;
        message.stockSplit = (object.stockSplit !== undefined && object.stockSplit !== null)
            ? exports.AddActivityRequestStockSplit.fromPartial(object.stockSplit)
            : undefined;
        message.stockSpinoff = (object.stockSpinoff !== undefined && object.stockSpinoff !== null)
            ? exports.AddActivityRequestStockSpinoff.fromPartial(object.stockSpinoff)
            : undefined;
        message.mergerAcquisition =
            (object.mergerAcquisition !== undefined && object.mergerAcquisition !== null)
                ? exports.AddActivityRequestMergerAcquisition.fromPartial(object.mergerAcquisition)
                : undefined;
        message.interestAdjustment =
            (object.interestAdjustment !== undefined && object.interestAdjustment !== null)
                ? exports.AddActivityRequestInterestAdjustment.fromPartial(object.interestAdjustment)
                : undefined;
        message.stockAdjustment =
            (object.stockAdjustment !== undefined && object.stockAdjustment !== null)
                ? exports.AddActivityRequestStockAdjustment.fromPartial(object.stockAdjustment)
                : undefined;
        message.deposit = (object.deposit !== undefined && object.deposit !== null)
            ? exports.AddActivityRequestDeposit.fromPartial(object.deposit)
            : undefined;
        message.withdrawal = (object.withdrawal !== undefined && object.withdrawal !== null)
            ? exports.AddActivityRequestWithdrawal.fromPartial(object.withdrawal)
            : undefined;
        message.cashJournal = (object.cashJournal !== undefined && object.cashJournal !== null)
            ? exports.AddActivityRequestCashJournal.fromPartial(object.cashJournal)
            : undefined;
        return message;
    },
};
function createBaseAddActivityRequestDividend() {
    return {};
}
exports.AddActivityRequestDividend = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestDividend.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestDividend();
        return message;
    },
};
function createBaseAddActivityRequestDividendTax() {
    return {};
}
exports.AddActivityRequestDividendTax = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestDividendTax.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestDividendTax();
        return message;
    },
};
function createBaseAddActivityRequestStockAdjustment() {
    return { orderHandle: stock_order_1.OrderHandle.fromPartial({}), side: stock_order_1.Side.INVALID_SIDE };
}
exports.AddActivityRequestStockAdjustment = {
    fromJSON(object) {
        const message = {
            orderHandle: isSet(object.orderHandle)
                ? stock_order_1.OrderHandle.fromJSON(object.orderHandle)
                : stock_order_1.OrderHandle.fromPartial({}),
            side: isSet(object.side) ? (0, stock_order_1.sideFromJSON)(object.side) : stock_order_1.Side.INVALID_SIDE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderHandle !== undefined) {
            obj.orderHandle = stock_order_1.OrderHandle.toJSON(message.orderHandle);
        }
        if (message.side !== stock_order_1.Side.INVALID_SIDE) {
            obj.side = (0, stock_order_1.sideToJSON)(message.side);
        }
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestStockAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddActivityRequestStockAdjustment();
        message.orderHandle = (object.orderHandle !== undefined && object.orderHandle !== null)
            ? stock_order_1.OrderHandle.fromPartial(object.orderHandle)
            : stock_order_1.OrderHandle.fromPartial({});
        message.side = object.side ?? stock_order_1.Side.INVALID_SIDE;
        return message;
    },
};
function createBaseAddActivityRequestStockSplit() {
    return {};
}
exports.AddActivityRequestStockSplit = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestStockSplit.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestStockSplit();
        return message;
    },
};
function createBaseAddActivityRequestStockSpinoff() {
    return {};
}
exports.AddActivityRequestStockSpinoff = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestStockSpinoff.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestStockSpinoff();
        return message;
    },
};
function createBaseAddActivityRequestMergerAcquisition() {
    return { type: stock_corporate_action_1.MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE };
}
exports.AddActivityRequestMergerAcquisition = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, stock_corporate_action_1.mergerAcquisitionTypeFromJSON)(object.type);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined &&
            message.type !== stock_corporate_action_1.MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE) {
            obj.type = (0, stock_corporate_action_1.mergerAcquisitionTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestMergerAcquisition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddActivityRequestMergerAcquisition();
        message.type = object.type ?? stock_corporate_action_1.MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE;
        return message;
    },
};
function createBaseAddActivityRequestInterestAdjustment() {
    return {};
}
exports.AddActivityRequestInterestAdjustment = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestInterestAdjustment.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestInterestAdjustment();
        return message;
    },
};
function createBaseAddActivityRequestDeposit() {
    return {};
}
exports.AddActivityRequestDeposit = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestDeposit.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestDeposit();
        return message;
    },
};
function createBaseAddActivityRequestWithdrawal() {
    return {};
}
exports.AddActivityRequestWithdrawal = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestWithdrawal.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestWithdrawal();
        return message;
    },
};
function createBaseAddActivityRequestCashJournal() {
    return {};
}
exports.AddActivityRequestCashJournal = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityRequestCashJournal.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityRequestCashJournal();
        return message;
    },
};
function createBaseAddActivityResponse() {
    return {};
}
exports.AddActivityResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddActivityResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddActivityResponse();
        return message;
    },
};
function createBaseGetIgnoreMarketHoursRequest() {
    return { userId: '' };
}
exports.GetIgnoreMarketHoursRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.GetIgnoreMarketHoursRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIgnoreMarketHoursRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseGetIgnoreMarketHoursResponse() {
    return { ignoreMarketHours: false };
}
exports.GetIgnoreMarketHoursResponse = {
    fromJSON(object) {
        const message = {
            ignoreMarketHours: isSet(object.ignoreMarketHours)
                ? globalThis.Boolean(object.ignoreMarketHours)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ignoreMarketHours !== false) {
            obj.ignoreMarketHours = message.ignoreMarketHours;
        }
        return obj;
    },
    create(base) {
        return exports.GetIgnoreMarketHoursResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIgnoreMarketHoursResponse();
        message.ignoreMarketHours = object.ignoreMarketHours ?? false;
        return message;
    },
};
function createBaseSetIgnoreMarketHoursRequest() {
    return { userId: '', ignoreMarketHours: false };
}
exports.SetIgnoreMarketHoursRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.ignoreMarketHours)) {
            message.ignoreMarketHours = globalThis.Boolean(object.ignoreMarketHours);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.ignoreMarketHours !== undefined && message.ignoreMarketHours !== false) {
            obj.ignoreMarketHours = message.ignoreMarketHours;
        }
        return obj;
    },
    create(base) {
        return exports.SetIgnoreMarketHoursRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetIgnoreMarketHoursRequest();
        message.userId = object.userId ?? '';
        message.ignoreMarketHours = object.ignoreMarketHours ?? false;
        return message;
    },
};
function createBaseSetIgnoreMarketHoursResponse() {
    return {};
}
exports.SetIgnoreMarketHoursResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetIgnoreMarketHoursResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetIgnoreMarketHoursResponse();
        return message;
    },
};
function createBaseSetGraduationTransferDelayRequest() {
    return { userId: '', delayMs: '0' };
}
exports.SetGraduationTransferDelayRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.delayMs)) {
            message.delayMs = globalThis.String(object.delayMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.delayMs !== undefined && message.delayMs !== '0') {
            obj.delayMs = message.delayMs;
        }
        return obj;
    },
    create(base) {
        return exports.SetGraduationTransferDelayRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetGraduationTransferDelayRequest();
        message.userId = object.userId ?? '';
        message.delayMs = object.delayMs ?? '0';
        return message;
    },
};
function createBaseSetGraduationTransferDelayResponse() {
    return {};
}
exports.SetGraduationTransferDelayResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetGraduationTransferDelayResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetGraduationTransferDelayResponse();
        return message;
    },
};
function createBaseAddTestDocumentRequest() {
    return { userId: '', type: TestDocumentType.INVALID_TEST_DOCUMENT_TYPE, displayName: '' };
}
exports.AddTestDocumentRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            type: isSet(object.type)
                ? testDocumentTypeFromJSON(object.type)
                : TestDocumentType.INVALID_TEST_DOCUMENT_TYPE,
        };
        if (isSet(object.displayName)) {
            message.displayName = globalThis.String(object.displayName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.type !== TestDocumentType.INVALID_TEST_DOCUMENT_TYPE) {
            obj.type = testDocumentTypeToJSON(message.type);
        }
        if (message.displayName !== undefined && message.displayName !== '') {
            obj.displayName = message.displayName;
        }
        return obj;
    },
    create(base) {
        return exports.AddTestDocumentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddTestDocumentRequest();
        message.userId = object.userId ?? '';
        message.type = object.type ?? TestDocumentType.INVALID_TEST_DOCUMENT_TYPE;
        message.displayName = object.displayName ?? '';
        return message;
    },
};
function createBaseAddTestDocumentResponse() {
    return {};
}
exports.AddTestDocumentResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddTestDocumentResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddTestDocumentResponse();
        return message;
    },
};
function testDocumentTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TEST_DOCUMENT_TYPE':
            return TestDocumentType.INVALID_TEST_DOCUMENT_TYPE;
        case 1:
        case 'MONTHLY_STATEMENT':
            return TestDocumentType.MONTHLY_STATEMENT;
        case 2:
        case 'TRADE_CONFIRMATION':
            return TestDocumentType.TRADE_CONFIRMATION;
        case 3:
        case 'TAX_DOCUMENT':
            return TestDocumentType.TAX_DOCUMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TestDocumentType.UNRECOGNIZED;
    }
}
exports.testDocumentTypeFromJSON = testDocumentTypeFromJSON;
function testDocumentTypeToJSON(object) {
    switch (object) {
        case TestDocumentType.INVALID_TEST_DOCUMENT_TYPE:
            return 'INVALID_TEST_DOCUMENT_TYPE';
        case TestDocumentType.MONTHLY_STATEMENT:
            return 'MONTHLY_STATEMENT';
        case TestDocumentType.TRADE_CONFIRMATION:
            return 'TRADE_CONFIRMATION';
        case TestDocumentType.TAX_DOCUMENT:
            return 'TAX_DOCUMENT';
        case TestDocumentType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.testDocumentTypeToJSON = testDocumentTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-testing-service.js.map